import { render, staticRenderFns } from "./NotePeriodicpopup.vue?vue&type=template&id=05bdf962&scoped=true"
import script from "./NotePeriodicpopup.vue?vue&type=script&lang=js"
export * from "./NotePeriodicpopup.vue?vue&type=script&lang=js"
import style0 from "./NotePeriodicpopup.vue?vue&type=style&index=0&id=05bdf962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bdf962",
  null
  
)

export default component.exports